import {HookReadMoreActions} from './read-more';
import {setWrapperWidth} from './owl-carousel';
import {toggleText} from './toggle-text';

var $ = jQuery;

window.addEventListener( 'DOMContentLoaded', () => {

	HookReadMoreActions( 'conference' );
	HookMenuOptions();
	HookFormAnchor();

	if ( $( window ).width() < 768 ) {
		$( "#prelegenci .wp-block-columns.owl-carousel" ).owlCarousel( {
			dots: false,
			loop: true,
			nav: false,
			items: 1,
			margin: 40,
			autoWidth: true,
			onInitialized: callback,
		} );

		setWrapperWidth( '#prelegenci .wp-block-columns.owl-carousel' );

		$( "#why-worth.owl-carousel" ).owlCarousel( {
			dots: true,
			loop: true,
			nav: false,
			items: 1,
			margin: 20,
			autoWidth: true,
		} );

		setWrapperWidth( '#why-worth.owl-carousel' );

		const priceItems = Array.from( document.querySelectorAll( '#cennik.owl-carousel .wp-block-column' ) );
		const activeItemIndex = priceItems.findIndex( item => item.querySelector( '.wp-block-pik-submit-to-training--active' ) );

		$( "#cennik.owl-carousel" ).owlCarousel( {
			dots: false,
			loop: true,
			nav: false,
			items: 1,
			margin: 10,
			autoWidth: true,
			startPosition: activeItemIndex > 0 ? activeItemIndex : 0,
		} );

		setWrapperWidth( '#cennik.owl-carousel' );
	}

	let asignButton = document.querySelector( ".wp-block-pik-submit-to-training--active .wp-block-pik-submit-to-training__submit > button" );

	if ( $( window ).width() < 768 ) {
		asignButton = document.querySelector( ".owl-item:not(.cloned) .wp-block-pik-submit-to-training--active .wp-block-pik-submit-to-training__submit > button" );
	}

	if ( asignButton ) {
		asignButton.addEventListener( 'click', ( event ) => {
			toggleForm( true, 'step1' )
		} )
	}

	window.addEventListener( 'HIDE_FORM', () => {
		toggleForm( false )
	} )

} )

const callback = () => {
	toggleText();
}

function toggleForm( state, setHash, skipScroll = false ) {
	let conferenceContentContainer = document.querySelector( '#page-content' )
	let form = document.querySelector( '#conferenceForm' )
	let formScrollAnchor = document.querySelector( '.saleForm_training_title_container' );
	const header = document.querySelector( 'header.header' );

	if ( state ) {
		if ( setHash ) {
			window.location.hash = setHash
		}

		conferenceContentContainer.classList.add( 'hidden' )
		form.classList.remove( 'hidden' )
		if ( ! skipScroll ) scrollIntoViewWithOffset( formScrollAnchor )

		header.classList.add( 'header--default' );
	} else {
		window.location.hash = ''
		conferenceContentContainer.classList.remove( 'hidden' )
		form.classList.add( 'hidden' )
		if ( ! skipScroll ) scrollIntoViewWithOffset( conferenceContentContainer )

		header.classList.remove( 'header--default' );
	}
}

/**
 * Intercepts conference menu anchor clicks to hide the sale form and scroll to the target section with header offset.
 */
function HookMenuOptions() {
	let allMenuLinks = document.querySelectorAll( '#conference-menu-list > li a' )
	if ( allMenuLinks ) {
		allMenuLinks.forEach( ( link ) => {
			link.addEventListener( 'click', ( event ) => {
				const href = link.getAttribute( 'href' )
				if ( href && href.startsWith( '#' ) ) {
					event.preventDefault()
					toggleForm( false, null, true )
					const target = document.getElementById( href.slice( 1 ) )
					if ( target ) {
						scrollIntoViewWithOffset( target )
					}
				}
			} )
		} )
	}
}

/**
 * Scrolls to the #formularz section with header offset.
 */
function HookFormAnchor() {
	const link = document.querySelector( 'a[href="#formularz"]' )
	const target = document.getElementById( 'formularz' )
	if ( ! link || ! target ) {
		return
	}

	link.addEventListener( 'click', ( event ) => {
		event.preventDefault()
		scrollIntoViewWithOffset( target )
	} )
}

const scrollIntoViewWithOffset = ( element, offsetOverwrite ) => {
	const header = document.querySelector( '#masthead' )
	const headerHeight = header.offsetHeight
	const offset = offsetOverwrite ? offsetOverwrite : headerHeight
	window.scrollTo( {
		behavior: 'smooth',
		top:
			element.getBoundingClientRect().top -
			document.body.getBoundingClientRect().top -
			offset,
	} )
}
